import NextLink from '@/components/next-link';

const ProductCardLabel = ({ brand, url, productName }) => {
  return (
    <div className='flex flex-col gap-1.5'>
      <p className='leading-4.5 font-semibold text-gray-500 max-sm:text-[10px] sm:text-xs md:text-sm'>
        {brand}
      </p>

      <NextLink
        href={`/product/${url}`?.replaceAll('.', '-')}
        className='line-clamp-2 h-12 max-md:h-11 max-md:text-[15px] max-sm:h-8 max-sm:text-xs'
      >
        {productName}
      </NextLink>
    </div>
  );
};

export default ProductCardLabel;
